module.exports = __webpack_public_path__ + "img/dys.67242dd7.png";